import { Palette } from '@mui/material';
import { PackageType } from '@retail/calculus/types';
import { HierarchyLevels } from '@retail/products/types';

interface Props {
  palette: Pick<Palette, 'divider' | 'semantic' | 'text'>;
  bindingType?: HierarchyLevels;
  packageType?: PackageType;
  active?: boolean;
}

export interface ChipColor {
  bg: string;
  text: string;
}

type Tint = Palette['semantic']['tint'][keyof Palette['semantic']['tint']];

const level = (tint: Tint, bg: 'soft' | 'medium' | 'strong'): ChipColor => ({
  bg: tint[bg],
  text: tint.text,
});

export const chipColor = ({ palette, bindingType, packageType, active }: Props): ChipColor => {
  const inactive = { bg: palette.divider, text: palette.text.primary };
  if (!active) {
    return inactive;
  }

  const { tint } = palette.semantic;
  switch (bindingType) {
    case 'ASSORTMENT':
      return level(tint.saffron, 'soft');
    case 'MG_PARTICIPANT_ACCOUNT':
      return level(tint.lavender, 'medium');
    case 'OVERGRUPPE':
      return level(tint.yellow, 'medium');
    case 'HOVEDGRUPPE':
      return level(tint.sky, 'strong');
    case 'VAREGRUPPE':
      return level(tint.orange, 'strong');
    case 'DISCOUNT_GROUP':
      return level(tint.saffron, 'strong');
    case 'MG_SUPPLIER_ITEM':
      switch (packageType) {
        case 'SECONDARY':
          return level(tint.pink, 'medium');
        case 'TERTIARY':
          return level(tint.red, 'strong');
        default:
          return level(tint.green, 'medium');
      }
    default:
      return inactive;
  }
};
